<template>
    <div>
        <form id="cnfmForm" name="cnfmForm" method="post" action="">
        </form>
        <v-dialog/>
    </div>
</template>

<script>
import { publicAuthResult } from '@/api/step3/identificationVerfication'
export default {
    name: "ResultNormalAuthPop",
    data() {
        return {
            encData: '',
            certRequestNum: '',
            custNm: '',
            custBday: '',
            custIpinCiNo: '',
            certDate: ''
        }
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        /** 
         * Function    : getInfo
         * Description : 범용공인인증서 결과 정보
         **/
        getInfo() {
            //    let rsltCd = this.$route.query.rsltCd
            //    let rsltMsg = this.$route.qeury.rsltMsg
            //     window.opener.cbAuthPop({
            //         rsltCd: rsltCd,
            //         rsltMsg: rsltMsg
            //     })
        //     let ret = decodeURIComponent(window.atob(decodeURIComponent(this.$route.query.ret)))
        //     let custInfo = ''
        //     if (ret) {
        //         custInfo = ret.split(',')
        //         if (custInfo === undefined || custInfo.length < 0 || custInfo === null)  {
        //             alert('인증을 실패 했습니다.')
        //             window.close()
        //         } else {
        //             window.opener.cbAuthPop({
        //                 name: custInfo[0],
        //                 phoneNo: '',
        //                 birthDay: custInfo[1]
        //             })
        //             window.close()
        //         }
        //     } else {
        //         alert('인증을 실패 했습니다. param='+ret)
        //         window.close()
        //     }
        //    let param =  {
        //        priinfo: priinfo,
        //        chrgPymnDivsCd: custKdCd === 'A' ? '2' : '1',
        //        onetMblAppfNo: onetMblAppfNo
        //    }

           let priinfo = this.$route.query.priinfo
         

            if(priinfo){
                 // alert("1")
                publicAuthResult(priinfo).then(res => {
                     //alert(res.data.dsRsltInfo.rsltCd )
                    if(res.data.dsRsltInfo.rsltCd === "SUCCESS") {
                        let returnValue = {
                            rsltCd: "SUCCESS",
                            rsltMsg: res.data.dsRsltInfo.rsltMsg,
                            dsRes :res.data.dsRes
                        }
                        window.opener.cbAuthPop(JSON.stringify(returnValue))
                        // alert(res.dsRsltInfo.rsltMsg)
                       window.close()
                    } else {
                        let rsltMsg=res.data.dsRsltInfo.rsltMsg
                        if(!rsltMsg){
                            rsltMsg ='인증을 실패 했습니다.\n다시 시도해주세요.'
                        }
                        alert(rsltMsg)
                       window.close()
                    }
                })
            } else {
                alert('인증을 실패 했습니다.\n다시 시도해주세요.')
                window.close()
            }
        },
    },
}
</script>

<style scoped>

</style>